import { isBrimley, isFlight, isImpact } from './dcContext'

const TRACKING_ID_LENGTH = 23
const LPN_LENGTH = 20
const FLIGHT_TRACKING_ID_LENGTH = 12
// AKA RA number
const CUSTPO_NUMBER_LENGTH = 15
const FLIGHT_PO_NUMBER_LENGTH = 14
const IMPACT_PO_NUMBER_LENGTH = 15
const FEDEX_NUMBER_LENGTH = 12
const S_LABEL_LENGTH = 8

export const getAcceptableRlpnLengths = () => {
  return isImpact
    ? [TRACKING_ID_LENGTH, LPN_LENGTH, IMPACT_PO_NUMBER_LENGTH]
    : isFlight
      ? [FLIGHT_TRACKING_ID_LENGTH, LPN_LENGTH, FLIGHT_PO_NUMBER_LENGTH]
      : isBrimley
        ? [FEDEX_NUMBER_LENGTH, CUSTPO_NUMBER_LENGTH, LPN_LENGTH]
        : [LPN_LENGTH]
}

export const getAcceptableToteLpnLengths = () => {
  return isBrimley
    ? [S_LABEL_LENGTH, LPN_LENGTH]
    : [LPN_LENGTH]
}
